import SubmittingTechnicalValidation, {
  SubmitProjectProps,
} from './SubmittingTechnicalValidation.container';

export type ProjectType = SubmitProjectProps;

export default SubmittingTechnicalValidation;
